import { useEffect, useRef, useState } from 'react';

export function formatBytes(bytes) {
  if (bytes == null || Number.isNaN(Number(bytes))) return '';
  const value = Number(bytes);
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${Math.round(value / 1024)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Object-URL lifecycle helper for a `File[]`. Returns preview URLs for the
 * current files, creating URLs for newly-added files and revoking URLs for
 * files that were removed (keeps blob URLs from leaking).
 */
export function useObjectUrls(files) {
  const [previews, setPreviews] = useState([]);
  const byFile = useRef(new Map());

  useEffect(() => {
    const current = new Set(files);
    for (const [file, url] of byFile.current) {
      if (!current.has(file)) {
        URL.revokeObjectURL(url);
        byFile.current.delete(file);
      }
    }
    const next = files.map((file) => {
      let url = byFile.current.get(file);
      if (!url) {
        url = URL.createObjectURL(file);
        byFile.current.set(file, url);
      }
      return url;
    });
    setPreviews(next);
  }, [files]);

  return previews;
}
